import React from 'react';
import { Spinner } from 'reactstrap';

const Loader: React.FC = () => {
  return <Spinner color="default" />;
};

export default Loader;
